import module from 'recursoshumanos/module.js'
import * as moment from 'moment'

const schema = {
  coincide_nombre: 'boolean',
  coincide_nss: 'boolean',
  coincide_salario: 'boolean',
  coincide_estatus: 'boolean',
}

export class RecursosHumanosVisorLotesLoteService {
  constructor ($http) {
    this.$http = $http
  }

  get (idEmpresa, folio, fecha) {
    return this.$http.get('/api/recursos_humanos/visor_lotes/lote', {
      params: {
        id_empresa: idEmpresa,
        folio: folio,
        fecha: moment(fecha).format('YYYY-MM-DD'),
      },
      schema,
    })
  }

  delete (folio) {
    return this.$http.delete('/api/recursos_humanos/visor_lotes/lote', {
      params: {
        folio: folio
      },
      schema,
    })
  }

}

module.service('RecursosHumanosVisorLotesLote', RecursosHumanosVisorLotesLoteService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/VisorLotes/Lote.js